module.exports = __webpack_public_path__ + "audio-ab2117829d33.m4a";